import { getCurrentLanguage } from "owa-localize";
import { logUsage } from "owa-analytics";
import getModuleContextMailboxInfo from "owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo";

export function isLocaleAvailable(): boolean {
    const currentLanguage = getCurrentLanguage().toLowerCase();
    
    const result = AvailableDiagnosticsLocales.some(locale => GetShortLocale(locale.toLowerCase()) === GetShortLocale(currentLanguage));
    
    if (!result) {
        logUsage("DiagnosticsAndSupport_Capabilities", getModuleContextMailboxInfo(), {
            currentLanguage,
            currentLanguageShort: GetShortLocale(currentLanguage),
        }, { sessionSampleRate: 1 });
    }
    
    return result;
}

function GetShortLocale(locale: string): string {
    if (locale.indexOf("zh") >= 0) {
        return locale;
    }
    
    if (locale.indexOf("-") >= 0) {
        return locale.split("-")[0];
    }
    
    return locale;
}

const AvailableDiagnosticsLocales = [
    "af",
    "am",
    "ar",
    "as-IN",
    "az-Latn-AZ",
    "bg",
    "bn-IN",
    "bs-Latn-BA",
    "ca",
    "ca-Es-VALENCIA",
    "cs",
    "cy",
    "da",
    "de",
    "el",
    "en-GB",
    "en-US",
    "es",
    "es-MX",
    "et",
    "eu",
    "fa",
    "fi",
    "fil",
    "fr",
    "fr-CA",
    "ga-IE",
    "gd-gb",
    "gl",
    "gu",
    "he",
    "hi",
    "hr",
    "hu",
    "hy",
    "id",
    "is",
    "it",
    "ja",
    "ka",
    "kk",
    "km-KH",
    "kn",
    "ko",
    "kok",
    "lb-LU",
    "lo-LA",
    "lt",
    "lv",
    "mi-NZ",
    "mk",
    "ml",
    "mr",
    "ms",
    "mt-MT",
    "ne-NP",
    "nl",
    "nn-NO",
    "no",
    "or",
    "pa-IN",
    "pl",
    "pt",
    "pt-PT",
    "quz-PE",
    "qps-ploc", // For testing purposes
    "ro",
    "ru",
    "sk",
    "sl",
    "sq",
    "sr",
    "sr-Cyrl",
    "sr-Cyrl-BA",
    "sv",
    "ta",
    "te",
    "th",
    "tr",
    "tt",
    "ug-CN",
    "uk",
    "ur",
    "uz",
    "vi",
    "zh-Hans",
    "zh-Hant",
];
